package com.steamstreet.vegasful.browser.public

import com.steamstreet.vegasful.browser.account.Account
import com.steamstreet.vegasful.browser.account.Account.initAuth
import com.steamstreet.vegasful.browser.account.Account.initializeAccountModules
import com.steamstreet.vegasful.browser.account.emailCaptureOverlay
import com.steamstreet.vegasful.browser.account.initAccountMenu
import com.steamstreet.vegasful.browser.account.onReady
import com.steamstreet.vegasful.web.analytics.Analytics
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.CustomEvent
import org.w3c.dom.Element
import org.w3c.dom.asList

/**
 * Initialize client application modules.
 */
fun initializeModules(only: String? = null) {
    document.addEventListener("RunVegasfulModule", { event ->
        val detail = event as CustomEvent
        val module = detail.detail.asDynamic().module as? String
        if (module != null) {
            initializeModules(module)
        }
    })

    document.querySelectorAll("[data-module]").asList().forEach {
        (it as? Element)?.let { element ->
            if (element.getAttribute("data-module-initialized") != "1") {
                element.getAttribute("data-module")?.let { module ->
                    if (only == null || module == only) {
                        modules[module]?.invoke(element)
                        element.setAttribute("data-module-initialized", "1")
                    }
                }
            }
        }
    }
}

/**
 * The mapping of modules.
 */
private val modules = mapOf<String, (Element) -> Unit>(
    "global-search" to ::globalSearch,
    "calendar-selection" to ::calendarSelector,
    "event-scroller" to ::eventScroller,
    "ios-webapp-back" to ::iosWebAppBack,
    "event-tag-filter" to ::eventTagFilter,
    "search-results" to ::searchResults,
    "event-dates-popup" to ::eventDates,
    "add-to-calendar" to ::addToCalendar,
    "venue-map" to ::venueMap,
    "load-more-events" to ::loadMoreEvents,
    "app-install" to ::appInstall,
    "home-hero" to ::homeHero,
)

fun main() {
    onReady {
        // Before anything else, so that a failure in the modules below is itself reported.
        Analytics.installErrorReporting()

        initAuth()

        // After initAuth, which is what establishes whether this visitor is signed in — the one
        // thing GA4's own automatic `page_view` cannot tell us and the whole reason this event
        // exists alongside it.
        Analytics.page(window.location.pathname, Account.isLoggedIn())

        initAccountMenu()
        initializeModules()
        initializeAccountModules()

        // The app-install bar and the footer store links are server-rendered and initialized by
        // `initializeModules` above, so nothing is called for them here. They used to be a
        // full-screen interstitial built and shown from this point in the sequence.

        // Offer email capture, but not before the visitor has navigated once.
        emailCaptureOverlay()
    }
}